import { tv } from '~/utils/tv'

export const RadioHelperTextVariants = tv({
  base: ` flex justify-start items-center gap-onepulse font-rdmodern font-semibold text-text-danger-alternative text-threepulse

  `,
  variants: {
    size: {
      md: 'px-fourpulse',
      ml: 'px-fourpulse',
      lg: 'px-fivepulse',
      xl: 'px-sixpulse',
    },
  },
  compoundVariants: [],
})
